export default __webpack_public_path__ + "static/media/serverless.487d419b.png";